import defaultQuote from 'taiwan_pcb/pcb_fabrication/data/defaultQuote';
import { START } from 'shared/data/quoteSteps';

export default {
  loading: false,
  quoteStep: START,
  quote: defaultQuote,
  parameters: {
    // qty1: 10,
    // qty2: 25,
    // qty3: 50,
    // qty4: 100,
    quantities: ['10', '25', '50', '100'],
    part_number: '',
    revision: '',
    number_of_layers: '2',
    board_length: '',
    board_width: '',

    has_array: '0',
    is_panelized: '',
    array_x: '',
    array_y: '',
    array_up: '',
    array_x_qty: '',
    array_y_qty: '',
    array_spacing_x: '',
    array_spacing_y: '',
    rails_left: '',
    rails_right: '',
    rails_top: '',
    rails_bottom: '',
    tab_rout: '0',
    scoring: '0',

    material_type: 'FR4',
    material_thickness: '0.062',
    finish_plating: 'Leaded Solder',
    copper_inners: '1 oz',
    copper_outers: '1 oz',
    //

    // min_trace_space  : 0.012,
    solder_sides: 'Both Sides',
    solder_color: 'green',
    silkscreen_sides: 'Both Sides',
    silkscreen_color: 'White',

    has_advanced_specs: '0',
    gold_fingers: '0',
    gold_thickness: 'Au < 10u"',
    pitch: '0.0',
    min_trace_space: '',
    blind_buried_hole: '',
    smallest_hole_size: '',


    plated_slots: '0',
    counterbores: '0',
    blind_slot: '0',
    plated_edges: '0',
    countersinks: '0',
    controlled_dielectric: '0',
    controlled_impedance: '0',

    special_instructions: '',

    quote_weight: '0',
    weight_unit: 'kg',
    row_selected: '',
    column_selected: '',
    email: Spree.current_user_email,

    castellation: '0',
    via_fill: 'none',
    rail_width: '',
  },
  parametersChanged: false,
  quantitiesChanged: false,
  emailQuoteError: false,
  currentVariant: null,
  productToCompare: null,
  lineItemId: null,
  destroy: false,
  suppliers: ['fabrication-tw-offshore-jet-pcb']
};
